import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@repo/ui/components/ui/sidebar";
import { Circle, CircleCheck } from "lucide-react";
import type { ConsentFormDto } from "@/shared/edge/queries";
import { nextUnsignedConsent } from "../next-unsigned";

export function ConsentSteps({ forms }: { forms: ConsentFormDto[] }) {
  const current = nextUnsignedConsent(forms);
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Consent forms</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {forms.map((form) => (
            <SidebarMenuItem key={form.key}>
              <SidebarMenuButton
                render={
                  <div
                    aria-current={form === current ? "step" : undefined}
                    data-active={form === current ? "true" : undefined}
                  />
                }
                className="pointer-events-none"
              >
                {form.signed ? (
                  <CircleCheck className="text-primary" aria-label="Signed" />
                ) : (
                  <Circle className="text-muted-foreground" aria-label="To sign" />
                )}
                <span>{form.title}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
